<template>
  <div
    class="p-pc"
    :class="scrollHideHeader ? 'scroll' : ''"
    ref="containerRef"
    @scroll="onPageScroll"
  >
    <Headers2023 v-if="isRoute2023"></Headers2023>
    <Headers v-else></Headers>
    <div class="p-pc-main">
      <router-view></router-view>
    </div>
    <Footers></Footers>
    <DynamicDialog />
  </div>
</template>

<script>
import Headers from '@/components/Header';
import Headers2023 from '@/components/Header2023';
import Footers from '@/components/Footer';
import DynamicDialog from '@/components/Dialog/dynamic.vue';
import { debounce } from 'lodash';
import { isSupportWebp } from '@/common/utils';
import { throttle } from 'lodash';

export default {
  name: 'pc',
  data() {
    return {
      isRoute2023: false,
      scrollHideHeader: false,
    };
  },
  components: { Headers, Headers2023, Footers, DynamicDialog },
  watch: {
    '$route.path': {
      handler(val, pre) {
        if (val !== pre) {
          this.$nextTick(() => {
            this.scrollHideHeader = false;
            this.$refs.containerRef.scrollIntoView();
          });
        }
      },
      immediate: true,
    },
  },
  async mounted() {
    const cacheScrollTop = sessionStorage.getItem('PAGE_SCROLL_TOP_CACHE_PC');
    this.setPageScrollTop(+cacheScrollTop);
    this.judgeIsRoute2023();
    await isSupportWebp();
    window.addEventListener('scroll', this.scrollFn);
    window.addEventListener('wheel', this.wheelFn);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.scrollFn);
    window.removeEventListener('wheel', this.wheelFn);
  },
  methods: {
    scrollFn: throttle(function () {
      if (
        this.$route.path === '/home' &&
        window.document.documentElement.scrollTop === 0
      ) {
        this.scrollHideHeader = false;
      }
    }, 300),

    wheelFn: throttle(function (event) {
      if (event.deltaY > 0) {
        this.scrollHideHeader =
          this.$route.path === '/home' &&
          window.document.documentElement.scrollTop > 500;
      } else if (event.deltaY < 0) {
        this.scrollHideHeader = false;
      }
    }, 300),

    onPageScroll: debounce(function () {
      const scrollTop = this.getPageScrollTop();
      sessionStorage.setItem('PAGE_SCROLL_TOP_CACHE_PC', scrollTop);
    }, 300),

    getPageScrollTop() {
      const scrollRef = this.$refs.containerRef;
      if (!scrollRef) return;
      return scrollRef.scrollTop;
    },

    setPageScrollTop(distance) {
      this.$nextTick(() => {
        const scrollRef = this.$refs.containerRef;
        if (!scrollRef) return;
        if (!distance) return;
        scrollRef.scrollTop = distance;
      });
    },

    judgeIsRoute2023() {
      const currentPath = this.$route.path;
      if (currentPath.includes('/2023/home')) {
        this.isRoute2023 = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.p-pc {
  min-height: 100%;
  min-width: 840px;

  &.scroll {
    :deep(.p-header) {
      opacity: 0;
      z-index: 0;
    }
    :deep(.p-home-navigation) {
      top: 16px;
    }
  }

  &-main {
    position: relative;
  }
}
</style>
